import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export default class FilesApi {
    static updateFile(institutionId, filePersistenceId, folderId = null, title, description) {
        return RESTClient.postAuthenticatedObservable('daycare/file/updatefile', {
            institutionId,
            filePersistenceId,
            folderId,
            title,
            description,
        });
    }

    static create(institutionId, fileId, title, description = '', folderId = null) {
        return RESTClient.postAuthenticatedObservable('daycare/file/createfile', {
            institutionId,
            fileId,
            title,
            description,
            folderId,
        });
    }

    static deleteFile(filePersistenceId) {
        return RESTClient.postAuthenticatedObservable('daycare/file/deletefile', {
            filePersistenceId,
        });
    }

    static fetchFoldersAndFiles(institutionId, folderId) {
        const folderString = folderId ? `/${folderId}` : '';
        return RESTClient.getAuthenticatedObservable(`v2/folders/${institutionId}${folderString}`);
    }

    static createFolder(institutionId, title, parent) {
        return RESTClient.postAuthenticatedObservable(`v2/folders/${institutionId}`, {
            title,
            parent,
        });
    }

    static changeFolderName(institutionId, folderId, title) {
        return RESTClient.putAuthenticatedObservable(`v2/folders/${institutionId}/${folderId}`, {
            title,
        });
    }

    static deleteFolder(institutionId, folderId) {
        return RESTClient.deleteAuthenticatedObservable(`v2/folders/${institutionId}/${folderId}`);
    }
}
